import React from "react";
import Store from "../../content/Store";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import { Paths } from "../../constants/UrlConstants";
import { Redirect } from "react-router-dom";
import styles from "../../assets/css/modules/health-store/health-store.css";
import c4cStyles from "../../assets/css/modules/health-support/c4c.css";
import ImageHeroContainer from "../shared/containers/ImageHeroContainer";
import NumberStepList from "../shared/groups/NumberStepList";

export const mapStateToCheckForCancer = (state) => {
  const currentPolicy = state.policyReducer.selectedPolicy;
  let isInternational, isLapsed;

  if (currentPolicy) {
    isInternational = currentPolicy.IsInternational;
    isLapsed = currentPolicy.IsLapsed;
  }

  return {
    isLapsed,
    isInternational
  };
};

export const CheckForCancer = function (props) {
  const content = props.content;
  return props.isInternational || props.isLapsed ? (
    <Redirect to={Paths.NotFound} />
  ) : (
    <React.Fragment>
      <div className="container">
        <div className={"row " + c4cStyles.c4c}>
          <div className="col-sm-12">
            <div className={styles.containerShadow}>
              <ImageHeroContainer
                bgImage={content.HeroBGSrc}
                bgImageMobile={content.HeroBGSrcMobile}
                bgImageTablet={content.HeroBGSrcTablet}
                bgAlt=""
                styleOverrides={c4cStyles}
              >
                <h1>{content.Heading}</h1>
                {content.Description}
              </ImageHeroContainer>
              <div className={c4cStyles.steps}>
                <div className="col-12">
                  <h2 id="c4cProcessHeader">{content.c4cProcessHeader}</h2>
                </div>
                <div className="col-lg-12">
                  <NumberStepList>
                    {content.discussWithYourGPDetail}
                    {content.callUsDetail}
                    {content.check4CancerDetail}
                  </NumberStepList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CheckForCancer.content = Store.Check4Cancer;

export default connect(mapStateToCheckForCancer)(Contentify(CheckForCancer));
